module.exports = __webpack_public_path__ + "fonts/fa-regular-400.7124eb50.woff";